// The over-box element pill (TopActionPill / AssessmentBoxMenu) is portalled
// into #topPillRoot at z-index 104 — above every right-rail drawer — so that a
// full-bleed element's pill is not drawn underneath the rail. The cost is that
// opening a drawer FROM that rail leaves the pill sitting on top of the very
// dialog the author just asked for (Aidea Wizard, Tools, Animation…).
//
// These two rules decide when the pill steps aside. EditorApp keeps the answer
// in `pillHiddenForTab` and mirrors it onto <body> as `right-drawer-open`,
// which _editorBox.scss hides the pill for — the same hook ToolsPanel and the
// crop overlay already use.

/**
 * The tab to dismiss the pill for after a rail tab is clicked. Only an
 * explicit click on top of a selected element counts: a drawer the app opened
 * by itself (ADD_BOX switching to Properties, an image selection switching to
 * Tools) must leave the pill alone, or it would be gone for most of a session.
 *
 * @param {?string} nextTab   the tab that ends up open (null when toggled shut)
 * @param {boolean} hasSelection whether an element is selected
 */
export function pillDismissalForTab(nextTab, hasSelection) {
  return nextTab && hasSelection ? nextTab : null;
}

/**
 * Whether a recorded dismissal has stopped applying — the drawer was closed or
 * switched somewhere other than the rail, or the selection moved to another
 * element, which hands the pill to that one.
 */
export function isPillDismissalStale({ pillHiddenForTab, activeTab, selectionChanged }) {
  if (!pillHiddenForTab) return false;
  return activeTab !== pillHiddenForTab || !!selectionChanged;
}
